module.exports = __webpack_public_path__ + "static/media/vizio-header-logo-case-number.6455568e.png";